import React from "react";
import { Chip, ChipProps } from "@mui/material";

export type WcChipProps = ChipProps & {
  label: string;
  controlDisabled?: boolean;
  variant?: string;
};

export const WcChip = ({
 
  label,
  controlDisabled = false,
  variant,
  ...props
}: WcChipProps) => (
  <Chip
    label={label}
    disabled={controlDisabled}
    variant={variant}
    {...props}
  />
);

export default WcChip;
